export default "__VITE_ASSET__DNM7Ax4Y__"